module.exports = {
    parse: require('./lib/parse'),
    stringify: require('./lib/stringify')
};
